import { render, staticRenderFns } from "./ScaleControli.vue?vue&type=template&id=2fe096c0&scoped=true"
import script from "./ScaleControli.vue?vue&type=script&lang=js"
export * from "./ScaleControli.vue?vue&type=script&lang=js"
import style0 from "./ScaleControli.vue?vue&type=style&index=0&id=2fe096c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe096c0",
  null
  
)

export default component.exports